import { Chip, Stack, Typography } from '@mui/material';

import { Filter } from '../../Filters.types';

export interface FilterListProps {
  selected?: Filter | null;
  items: Filter[];
  onFilterSelect: (filter: Filter) => void;
}

export const FilterList = ({ selected, items, onFilterSelect }: FilterListProps) => {
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        overflow: 'hidden',
        alignItems: 'center',
      }}
    >
      {items.map((filter) => {
        return (
          <Chip
            color={filter === selected ? 'primary' : undefined}
            key={filter.id}
            label={<Typography variant="button">{filter.name}</Typography>}
            variant={filter === selected ? 'filled' : 'outlined'}
            onClick={() => onFilterSelect(filter)}
          />
        );
      })}
    </Stack>
  );
};
